import { createContext } from "react";

import type { AttachmentOut, CorrespondenceOut } from "@/api";

/**
 * What an entry needs to know from the record around it — which entries were
 * just filed (Task 8), which attachments were just adopted and the gestures
 * (Task 9; the customer from a mail, spec 2026-10-20). A context rather than props through `EntryList`, so the
 * list stays as Task 7 writes it while the record grows around it.
 */
export interface EntryMarks {
  /** Entries filed a moment ago — marked for 2 s (UX ruling 7; UX gate round 2, #5). */
  fresh: ReadonlySet<string>;
  /**
   * attachment id → what „Als Zeichnung übernehmen" said, shown at the entry
   * it was pressed on (UX ruling 8); `done` puts „→ Zeichnungen" on the chip.
   */
  adopted: ReadonlyMap<string, { sentence: string; done: boolean }>;
  onRetract?: (entry: CorrespondenceOut) => void;
  onAdopt?: (entry: CorrespondenceOut, attachment: AttachmentOut) => void;
  /**
   * „Bild als Zeichnung übernehmen …" (UX-Gutachten 2, B-1): the chooser,
   * for an entry with more files to adopt than the menu lists one by one
   * (`ADOPT_ITEMS_MAX`). What is chosen goes the way of `onAdopt`.
   */
  onChooseDrawing?: (entry: CorrespondenceOut) => void;
  /**
   * „Kunde aus dieser Mail“ (spec 2026-10-20 §3.3): offered at a mail, not at
   * a note or a file. Absent where the Vorgang takes no customer.
   */
  onCustomer?: (entry: CorrespondenceOut) => void;
}

export const EntryMarksContext = createContext<EntryMarks>({ fresh: new Set(), adopted: new Map() });
